export default __webpack_public_path__ + "static/media/authenPass.03345433.svg";